const opCodes = {
    //general
    updateMatchListing: 4,
    opponentDisconnected: 444,
    opponentReconnected: 555,
    playerDisconnected: 666, //for spectators
    playerReconnected: 777, //for spectators

    //lobby
    matchStartPlayer1: 7,
    matchStartPlayer2: 8,
    rejoinDeckBuilder: 9,

    //deck builder
    playerReady: 163, //client sends this op code
    notReady: 165,
    player1Info: 148,
    player2Info: 149,
    updateDeckBuilderTimer: 150,
    winMatch: 104,
    illegitimateMatch: 169,

    //game
    waitingMatchStart: 98,
    waitingMatchStartSpectator: 1998,
    gameData: 99,
    gameDataSpectator: 1999,
    updateTurnTimer: 100,
    // winRound: 101,
    // loseRound: 102,
    tieRound: 103,
    tieRoundSpectator: 2003,
    //loseMatch: 105,
    playerPlayPowerCard: 1844, //client sends this op code
    playerStand: 1845, //client sends this op code
    playerEndTurn: 1846, //client sends this op code
    playerForfeit: 1847, //client sends this op code
    playerSendEmojiData: 1848, //client sends this op code
    serverSendEmojiData: 1849,
    spectatorSendEmojiData: 1850,
}

export default opCodes;